'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var debug = require('debug');
var utils = require('../../../utils.js');
var errCode = require('err-code');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);
var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

const log = debug__default["default"]('ipfs:mfs:utils:update-mfs-root');
async function updateMfsRoot(context, cid, options) {
  if (options && options.signal && options.signal.aborted) {
    throw errCode__default["default"](new Error('Request aborted'), 'ERR_ABORTED', { name: 'Aborted' });
  }
  log(`New MFS root will be ${ cid }`);
  await context.repo.datastore.put(utils.MFS_ROOT_KEY, cid.bytes);
  return cid;
}

exports.updateMfsRoot = updateMfsRoot;
